// extracted by mini-css-extract-plugin
export default {"brandPromo":"KG-z","carousel":"LG-z"};